import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'creditCardType'
})

export class CreditCardTypePipe implements PipeTransform {

  transform(value: string): string {
    switch (value) {
      case 'vi':
        return 'Visa';
      case 'mc':
        return 'Mastercard'
      case 'ax':
        return 'American Express'
      case 'di':
        return 'Diners';
      default:
        return 'Default';
    }
  }
}


// WEBPACK FOOTER //
// ./src/pipes/credit-card-type.pipe.ts